export const HeaderDeliveryConstant = {
  deliveryButtons: [
    {
      icon: 'fa-share-square',
      id: 'share',
      class: '',
      offline: false,
    },
    {
      id: 'offline',
      offline: true,
    },
    {
      id: 'favorite',
      offline: false,
    },
    {
      icon: 'fa-user-cog',
      id: 'user',
      class: '',
      offline: true,
    },
  ],
};
